import React from 'react'
import styled, { css } from 'styled-components'
import {
  color,
  fontSize,
  margin,
  MarginProps,
  TextColorProps,
  FontSizeProps,
  BackgroundColorProps,
  PaddingProps,
  padding,
  BorderProps,
  border,
  borderRadius,
  background,
  BackgroundProps,
} from 'styled-system'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export type IconProps = TextColorProps &
  FontSizeProps &
  MarginProps & {
    name?: string
    icon: any
    color?: string
    fontSize?: string | number
    onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void
  }

export type IconBgProps = TextColorProps &
  FontSizeProps &
  MarginProps &
  PaddingProps &
  BorderProps &
  BackgroundProps &
  BackgroundColorProps & {
    name?: string
    icon: any
    color?: string
    fontSize?: string | number
    onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void
  }

const Icon = ({ color = 'blue1', fontSize = 16, ...props }: IconProps) => {
  if (React.isValidElement(props.icon)) {
    const { name, icon, onClick, ...rest } = props
    return (
      <button style={{ padding: '0', height: '17px' }} onClick={onClick} {...rest}>
        {props?.icon}
      </button>
    )
  }
  return <StyledIcon color={color} fontSize={fontSize} {...props} />
}

const StyledIcon = styled(({ marginLeft, marginRight, marginTop, marginBottom, margin, backgroundColor, ...p }) => (
  <FontAwesomeIcon {...p} />
))<TextColorProps & FontSizeProps & MarginProps>`
  ${color}
  ${fontSize}
  ${margin}
  ${(p) =>
    !!p.onClick
      ? css`
          :hover {
            cursor: pointer;
          }
        `
      : null}
`

const IconBg = ({ ...props }: IconBgProps) => {
  if (React.isValidElement(props.icon)) {
    const { name, icon, color, background, onClick, ...rest } = props
    return (
      <button style={{ padding: '0', height: '17px' }} onClick={onClick} {...rest}>
        {props?.icon}
      </button>
    )
  }
  return <StyledIconWithBg {...props} />
}

const StyledIconWithBg = styled(
  ({
    marginLeft,
    marginRight,
    marginTop,
    marginBottom,
    margin,
    padding,
    paddingLeft,
    paddingRight,
    paddingTop,
    paddingBottom,
    border,
    background,
    backgroundColor,
    borderRadius,
    ...p
  }) => <FontAwesomeIcon {...p} />,
)<TextColorProps & FontSizeProps & MarginProps & PaddingProps & BackgroundProps & BackgroundColorProps & BorderProps>`
  ${color}
  ${fontSize}
  ${background}
  ${margin}
  ${padding}
  ${border}
  ${borderRadius}
  ${(p) =>
    !!p.onClick
      ? css`
          :hover {
            cursor: pointer;
          }
        `
      : null}
`

export default Icon
export { IconBg }
